import clsx from 'clsx';
import { envLabel } from 'constants/app-info';
import styles from './auth-layout.module.scss';

/**
 * Nhãn môi trường (LOCAL / DEV / UAT...). Không render gì khi REACT_APP_ENV là production
 * hoặc rỗng — nên nếu bản production hiện nhãn này thì build đang thiếu REACT_APP_ENV=production.
 */
const EnvBadge = ({ className }: { className?: string }) => {
  const label = envLabel();
  if (!label) return null;
  return (
    <span
      className={clsx(styles.envBadge, className)}
      aria-label={`Môi trường: ${label}`}
      title="Đây không phải bản chính thức"
    >
      {label}
    </span>
  );
};

export default EnvBadge;
